/**
 * contestedFieldUtils — F-005 Phase 5 (IMPL-P5-004).
 *
 * Helper condivisi dai field component per renderizzare lo stato "contestato"
 * (campo segnalato dall'operatore in fase di blocco pratica). Mantiene la
 * stessa stringa di classi Tailwind in tutti i field component, e fornisce
 * un id deterministico per il `<span>` sr-only collegato via aria-describedby.
 */

/** Tailwind ring amber applicato all'input quando il path è contestato. */
export const CONTESTED_RING_CLASS = 'ring-2 ring-amber-400 ring-offset-2';

/** Testo sr-only mostrato accanto al campo contestato (per AT). */
export const CONTESTED_HINT_TEXT =
  "Campo segnalato dall'operatore — verificare e correggere";

/**
 * Restituisce un id stabile per il `<span>` sr-only associato al field path
 * (es. `contested-hint-locatore-codiceFiscale`). Sostituisce i punti con
 * trattini per mantenere l'id valido HTML5.
 */
export function contestedHintId(fieldPath: string): string {
  return `contested-hint-${fieldPath.replace(/\./g, '-')}`;
}
